import _ from 'lodash'
import React from 'react'
import { Input } from 'semantic-ui-react'
import { ColorNames } from '../../../constants/colorVars'
import Icon from '../icon'
import classnames from 'classnames/bind'
import styles from './styles.scss'

const cx = classnames.bind(styles)

type ButtonWidth = undefined | 'fluid'

interface SearchFilterProps {
  elmId?: string
  onClick?: () => void
  onSearchIconClick?: () => void
  onResetIconClick: () => void
  label?: string
  disabled?: boolean
  placeholder?: string
  onChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    data: Record<string, unknown>
  ) => void
  value?: string
  inputRef?: React.RefObject<HTMLInputElement>
  width?: ButtonWidth
  size?: 'small' | 'medium'
  compact?: boolean
}

const SearchFilter = ({
  elmId = 'search_filter',
  onSearchIconClick = () => undefined,
  onResetIconClick,
  disabled,
  placeholder = 'Search...',
  onChange,
  onClick,
  value = '',
  inputRef,
  width,
  size = 'medium',
}: SearchFilterProps) => {
  const isEmpty = _.isEmpty(value)

  return (
    <div
      className={cx(
        'search-filter',
        { active: !isEmpty },
        { 'fluid-width': width === 'fluid' },
        {
          small: size === 'small',
          medium: size === 'medium',
        }
      )}
    >
      <Input
        // @ts-ignore next line
        ref={inputRef}
        data-elm-id={`${elmId}_input`}
        onChange={onChange}
        onClick={onClick}
        value={value}
        icon={{
          name: 'search',
          link: true,
          onClick: onSearchIconClick,
        }}
        placeholder={placeholder}
        disabled={disabled}
        iconPosition='left'
        // compact={size === 'small'}
      />
      {!isEmpty && (
        <div
          className={cx('reset-button')}
          data-elm-id={`${elmId}_reset`}
          onClick={onResetIconClick}
        >
          <Icon
            className={cx('icon')}
            color={ColorNames.Action}
            iconStyle='solid'
            name='xmark'
            size='medium'
            fitted
          />
        </div>
      )}
    </div>
  )
}

export default SearchFilter
